import { useMemo } from 'react';

import type { HTTPHeaders } from '@rtkwlf/asset-data-service';
import { Configuration, UserApi } from '@rtkwlf/capability';

import { useAuthContext } from '@packages/legacy/auth';
import { env } from '@packages/utils/env';

export const useCapabilityApi = (headers?: HTTPHeaders) => {
  const { fetchApi } = useAuthContext();

  return useMemo(() => {
    const basePath = env.VITE_CAPABILITY_BASE_PATH;

    return new UserApi(
      new Configuration({
        basePath,
        fetchApi,
        headers,
      }),
    );
  }, [fetchApi, headers]);
};
